import React, { useCallback, useRef } from 'react';
import { ConfigProvider } from 'antd';

import { WizardJumpContext } from '../../wizard/components/WizardNav';
import { WizardRoot } from '../../wizard/wizardStyles';

interface IConfigWizardRootProps {
  testId: string;
  step: string;
  /** The bar's earlier segments jump back to that step number; `null` draws a plain bar. */
  onJump: ((step: number) => void) | null;
  children: React.ReactNode;
}

/** The dark skin and popup home of the campaign wizard, around one Config Studio flow. */
const ConfigWizardRoot: React.FC<IConfigWizardRootProps> = ({ testId, step, onJump, children }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const popupContainer = useCallback(() => rootRef.current ?? document.body, []);
  return (
    <ConfigProvider getPopupContainer={popupContainer}>
      <WizardRoot ref={rootRef} data-testid={testId} data-step={step}>
        <WizardJumpContext.Provider value={onJump}>{children}</WizardJumpContext.Provider>
      </WizardRoot>
    </ConfigProvider>
  );
};

export default ConfigWizardRoot;
